const resource = {
  DESCRIPTIONS: {
    OUTBOUND:
      'Passport requests you have made, either to unlock your own passport or to view a candidate you have found. While a request is pending or rejected the passport stays anonymous; once approved it shows in full.',
    INBOUND:
      'Passport requests awaiting your approval, from candidates you manage. Approve to unlock the named passport; until then only anonymous results are shown.',
  },
};

export default resource;
